export const SET_CHECK_PERMISSION_OK = 'SET_CHECK_PERMISSION_OK';
export const SET_DATA_USER_LOGIN = 'SET_DATA_USER_LOGIN';
export const SET_DATA_ACCESS_TOKEN = 'SET_DATA_ACCESS_TOKEN';
export const SET_DATA_CATEGORYS = 'SET_DATA_CATEGORYS';
export const SET_DATA_PRODUCT = 'SET_DATA_PRODUCT';
export const SET_DATA_CUSTOMERS = 'SET_DATA_CUSTOMERS';
export const SET_DATA_BILLS = 'SET_DATA_BILLS';
export const SET_DATA_INSURANCESS = 'SET_DATA_INSURANCESS';

export const SET_UI_OPEN_NAV_LEFT = 'SET_UI_OPEN_NAV_LEFT';
export const SET_UI_LOAD_MARK = 'SET_UI_LOAD_MARK';

export const SET_APP_VIEW_ACTIVE = 'SET_APP_VIEW_ACTIVE';
export const SET_APP_OPEN_DIALOG_ADD_NEW = 'SET_APP_OPEN_DIALOG_ADD_NEW';
export const SET_APP_OPEN_DIALOG_EDIT = 'SET_APP_OPEN_DIALOG_EDIT';
export const SET_APP_OPEN_DIALOG_DETAIL = 'SET_APP_OPEN_DIALOG_DETAIL';
export const SET_APP_SNACK_BAR = 'SET_APP_SNACK_BAR';
export const SET_APP_KEY_SEARCH_ITEM_LIST = 'SET_APP_KEY_SEARCH_ITEM_LIST';
export const SET_APP_GRID_IS_LOADING = 'SET_APP_GRID_IS_LOADING';
export const SET_APP_IS_LOADING_ALL_DATA = 'SET_APP_IS_LOADING_ALL_DATA';
export const SET_APP_IS_LOADING_CATEGORYS = 'SET_APP_IS_LOADING_CATEGORYS';
export const SET_APP_IS_LOADING_PRODUCTS = 'SET_APP_IS_LOADING_PRODUCTS';
export const SET_APP_IS_LOADING_BILLS = 'SET_APP_IS_LOADING_BILLS';
export const SET_APP_IS_LOADING_INSURANCES = 'SET_APP_IS_LOADING_INSURANCES';
export const SET_APP_IS_LOADING_CUSTOMERS = 'SET_APP_IS_LOADING_CUSTOMERS';

